import secondImage from "../../assets/images/icons/no_results.svg";
import log from "../../assets/images/icons/logoOfNoResult.svg";
import { useTranslation } from "react-i18next";
function NoResult({
  title,
  isWithLogo,
}: {
  title?: string;
  isWithLogo?: boolean;
}) {
  const { t } = useTranslation();
  return (
    <div className="mx-auto mt-4 flex w-full max-w-64 flex-col items-center justify-center gap-4 text-center text-lg">
      {isWithLogo ? (
        <img src={log} alt="No Results" />
      ) : (
        <img src={secondImage} alt="No Results" />
      )}
      <p className={`${isWithLogo ? "text-primary-textFont" : "font-bold"}`}>
        {t("no_results_found")}
      </p>
      {title && <p>{t(title)}</p>}
    </div>
  );
}

export default NoResult;
